export default __webpack_public_path__ + "atomic/_patterns/02-molecules/jumbotron/_jumbotron.twig";